<template>
  <div class="transition">
    <BasicText size="h5">Quel mode de rattachement voulez-vous utiliser ?</BasicText>
    <div class="flex flex-row flex-gap-8 flex-align-start">
      <div class="transition-items flex-1">
        <BasicCheckbox
          :label="`Finaliser une demande avec un code d’activation ${ libConxtext }`"
          @update:model-value="modeRattachement = 'code'"
          :model-value="modeRattachement === 'code'"
        />
        <BasicAlert
          alert-type="info"
          alert-label="Je dispose d’un code d’activation, pour mon entreprise, reçu par courrier"
          class="flex-none"
        />
      </div>
      <img
        class="flex-none align-self-flex-start"
        src="@/assets/miniatures/courrier-code.png"
        alt="code d'activation"
      />
    </div>
    <div class="transition-items">
      <BasicCheckbox
        label="Effectuer une nouvelle demande avec le SIREN de mon entreprise"
        @update:model-value="modeRattachement = 'siren-siret'"
        :model-value="modeRattachement === 'siren-siret'"
        class="checkbox-siren"
      />
      <BasicAlert
        alert-type="info"
        alert-label="Choisissez cette option si vous ne disposez pas d’un code d’activation		"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { BasicAlert, BasicCheckbox, BasicText } from '@designSystem/components'
  import type { DemandeRattachementResult } from '../types'
  import { computed } from 'vue'
  import {
    type ContextAppType,
  } from '@/features/auth/context-app'

  type In = ContextAppType
  type Out = Pick<DemandeRattachementResult, 'modeRattachement'>

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const libConxtext = computed(() =>
    props.in === 'adherent' ? 'adhérent' : 'prestataire de formation',
  )

  const modeRattachement = computed({
    get: () => props.out?.modeRattachement,
    set: (value) => emits('outChanged', true, { modeRattachement: value! }),
  })
</script>

<style lang="less" scoped>
  @import './ChoixCarte.less';

  .checkbox {
    margin-left: 11px;
  }

  .icon {
    transform: scale(2);
    margin: 24px;
  }
  img {
    box-shadow: 2px 4px 12px 2px rgba(0, 0, 0, 0.15);
    border: none;
    background-color: white;    border-radius: 4px;
    margin: 0 0 -50px 0;
    padding: 6px 0 4px 0;
    width: 100px;
    object-fit: contain;
    object-position: center;
  }

  .checkbox-siren {
    padding-right: 120px;
  }

  @media (max-width: 550px ) {
    .checkbox-siren {
      padding-right: 0;
    }
  }

</style>
